<template>
  <div class="contents_wrapper">
    <Header :title="'空室検索'"/>
    <div class="contents">
      <div class="search_main">
        <div class="search_text">会議の終了時間を選択してください</div>
        <ul class="search_time">
          <li v-for="candidate in candidates" class="search_time_item" v-bind:key="candidate.key">
            <a
              href="javascript:void(0)"
              @click="search(candidate.value)"
              class="search_time_item_a"
            >
              <div class="time_item_icon">
                <img :src="$designResource.iconClock3" alt>
              </div>
              <div class="time_item_text">{{"～ " + candidate.value.format('HH:mm')}}</div>
            </a>
          </li>
        </ul>
        <ButtonGroup></ButtonGroup>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import ButtonGroup from "../components/ButtonGroup.vue";
import timeOptionService from "../services/timeOptionService";
import loggerService from "../services/loggerService";
import moment from "moment";

export default {
  components: {
    Header,
    ButtonGroup
  },
  data: function() {
    return {
      now: new Date(),
      candidates: []
    };
  },
  created: function() {
    loggerService.pageView("SearchEndTime");
    this.now = new Date();
    this.candidates = timeOptionService.getSeleteableTimes(
      this.now,
      moment(this.now)
        .add(74, "m")
        .toDate()
    );
  },
  methods: {
    search: function(time) {
      this.$router.push({
        path: `/criteria`,
        query: {
          targetTime: time.toDate().getTime()
        }
      });
    }
  }
};
</script>

<style lang="scss">
.search_main {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}
.search_text {
  color: $txtColor;
  font-size: 18px;
  width: 100%;
  text-align: center;
}
.search_time {
  width: 100%;
  padding: 0 10%;
  box-sizing: border-box;
  margin-top: 40px;
  margin-bottom: 40px;
}
.search_time_item {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 14px;
  background-color: #fff;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.3);
}
.search_time_item_a {
  position: relative;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
}
.time_item_icon {
  position: absolute;
}
.time_item_icon > img {
  width: 28px;
}
.time_item_text {
  font-size: 22px;
  text-align: center;
  width: 100%;
}
/** 反転 **/
.search_time_item.active {
  background-color: $txtColor;
}
.search_time_item.active .search_time_item_a {
  color: #fff;
}
</style>